import service from "@/utils/request";

export const getOSSConfig = () => {
  return service({
    url: "/api/v1/oss/token",
    method: "get",
  });
};
